const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const fmt = (d) => d.toISOString().split("T")[0];

async function fetchPage(ownerId, token, startDate, endDate, page, pageSize) {
  const params = new URLSearchParams({
    trend_type:       "vital_trends",
    patient_owner_id: ownerId,
    start_date:       startDate,
    end_date:         endDate,
    page,
    page_size:        pageSize
  });

  const url = `${BASE_URL}/api/patients/health/trends?${params}`;
  console.log(`🔵 Fetching page ${page}:`, url);

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization:  `Bearer ${token}`
    }
  });

  return response.json();
}

async function fetchPagesWithConcurrency(ownerId, token, startDate, endDate, pageNums, pageSize, limit = 3) {
  const results = new Array(pageNums.length);
  let cursor = 0;

  async function worker() {
    while (cursor < pageNums.length) {
      const idx  = cursor++;
      const page = pageNums[idx];
      results[idx] = await fetchPage(ownerId, token, startDate, endDate, page, pageSize);
    }
  }

  await Promise.all(Array.from({ length: limit }, worker));
  return results;
}

// ← accepts selectedDate now; fetches ±1 day around it
export async function fetchHealthTrends(ownerId, selectedDate = new Date()) {
  try {
    const token = localStorage.getItem("token");

    const start = new Date(selectedDate);
    start.setDate(start.getDate() - 1);
    const end = new Date(selectedDate);
    end.setDate(end.getDate() + 1);

    const startDate = fmt(start);
    const endDate   = fmt(end);
    const PAGE_SIZE   = 250;
    const CONCURRENCY = 3;

    console.log(`📅 Fetching trends: ${startDate} → ${endDate}`);

    const firstData = await fetchPage(ownerId, token, startDate, endDate, 1, PAGE_SIZE);

    const result      = firstData?.data?.result;
    const totalPages  = result?.wearable_trends?.total_pages ?? 1;
    const allWearable = [...(result?.wearable_trends?.data || [])];

    console.log(`🟢 Page 1 | total_pages: ${totalPages} | wearable: ${allWearable.length}`);
    console.log(`📦 cgm_trends count: ${result?.cgm_trends?.length ?? "key missing"}`);

    if (totalPages > 1) {
      const pageNums = Array.from({ length: totalPages - 1 }, (_, i) => i + 2);

      const restData = await fetchPagesWithConcurrency(
        ownerId, token, startDate, endDate, pageNums, PAGE_SIZE, CONCURRENCY
      );

      restData.forEach((d, i) => {
        const pageWearable = d?.data?.result?.wearable_trends?.data || [];
        console.log(`🟢 Page ${i + 2} | wearable: ${pageWearable.length}`);
        allWearable.push(...pageWearable);
      });
    }

    console.log(`✅ Total wearable records: ${allWearable.length}`);

    return {
      ...firstData,
      data: {
        ...firstData.data,
        result: {
          ...result,
          wearable_trends: {
            ...result?.wearable_trends,
            data: allWearable
          }
        }
      }
    };

  } catch (error) {
    console.error("Health trends fetch failed:", error);
  }
}